<app-web-navbar></app-web-navbar>

<section class="detail-page-wrapper">
  <section class="bread-crumb mt-2">
    <div class="container-fluid">
      <div class="row align-items-center text-center text-lg-start">
        <!-- Newsletter Subscription -->
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb  px-lg-2 py-3">
            <li class="breadcrumb-item text-muted" type="button" [routerLink]="['/']">Home</li>
            <li class="breadcrumb-item text-muted" type="button" [routerLink]="['/']"> {{
              this.product.categoryDetails.categoryName }}</li>
            <li class="breadcrumb-item active text-primary" type="button" aria-current="page">
              {{ this.product.productName }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </section>

  <!-- product-detail -->

  <section class="details-design px-2">
    <div class="container-fluid">
      <!-- image,product-details -->
      <div class="row">
        <div class="col-auto d-none d-md-block">
          <div class="d-flex flex-column gap-2 mb-2">
            <div *ngFor="let i of this.product.imageDetails" (mouseover)="changeImage(i.imageDetailsId)">
              <div class="thumbnail-img-container">
                <img [src]="this.endpoint+'/api/product/image-details/get/'+i.imageDetailsId"
                  class="img-thumbnail thumbnail-image" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5" (mouseleave)="getImageId(product.imageDetails)">
          <div class="row">

            <div class="">
              <div class="detail-img-container px-2">
                <div class="mainImage-container">
                  <img class="img-fluid detail-img" loading="lazy"
                    [src]="this.endpoint+'/api/product/image-details/get/' + this.mainImageId + '?size=medium'"
                    alt="{{ this.product.productName }}" />
                </div>
                <div class="mt-4  d-block d-md-none">
                  <swiper [config]="brandImagesConfig" class="subImage-swiper">
                    <ng-container *ngFor="let i of product.imageDetails">
                      <ng-template swiperSlide>
                        <div class="d-flex flex-column gap-2 mb-2">
                          <div *ngFor="let i of this.product.imageDetails" (mouseover)="changeImage(i.imageDetailsId)">
                            <div class="thumbnail-img-container">
                              <img [src]="this.endpoint+'/api/product/image-details/get/'+i.imageDetailsId"
                                class="img-thumbnail thumbnail-image" />
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-container>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 px-2 px-lg-4">
          <!-- Product Name & Availability -->
          <div class="detail-header">
            <h1 class="detail-product-name josefin-sans-bold">{{ this.product.productName }}</h1>
            <span class="detail-availability-badge" *ngIf="product.availability === 'Yes'">
              <span class="badge-dot"></span> In Stock
            </span>
            <span class="detail-out-of-stock-badge" *ngIf="product.availability !== 'Yes'">
              Out of Stock
            </span>
          </div>

          <!-- Price Section -->
          <div class="detail-price-section">
            <span class="detail-srp josefin-sans-bold" *ngIf="product.srp">₹{{ product.srp }}</span>
          </div>

          <!-- Product Highlights -->
          <div class="detail-highlights">
            <div class="highlight-chip" *ngIf="product.totalQuantity">
              <span class="highlight-icon">⚖</span>
              <span class="highlight-label">Weight</span>
              <span class="highlight-value">{{ product.totalQuantity }} {{ product.unit || 'g' }}</span>
            </div>
            <div class="highlight-chip" *ngIf="product.noOfPcsPerPkt">
              <span class="highlight-icon">📦</span>
              <span class="highlight-label">Pack</span>
              <span class="highlight-value">{{ product.noOfPcsPerPkt }} pcs</span>
            </div>
            <div class="highlight-chip" *ngIf="product.mrp && !product.srp">
              <span class="highlight-icon">💰</span>
              <span class="highlight-label">MRP</span>
              <span class="highlight-value">₹{{ product.mrp }}</span>
            </div>
          </div>

          <!-- Description -->
          <div class="detail-description-card" *ngIf="product.description">
            <h5 class="detail-desc-title josefin-sans-bold">
              <span class="desc-icon">📝</span> Description
            </h5>
            <p class="detail-desc-text josefin-sans-medium" [innerHTML]="product.description"></p>
          </div>

          <!-- Enquiry Button -->
          <div class="detail-actions">
            <button class="detail-enquiry-btn josefin-sans-bold" (click)="showPopup()">
              <span class="btn-icon">📞</span> Enquiry Now
            </button>
          </div>
        </div>
      </div>




      <!-- product-description -->

      <div class="row mt-5 py-2 pb-5" *ngIf="hasAnyProductDetail()">

        <div class="row d-flex mb-3 mt-2">
          <!-- <h4 class="text-muted josefin-sans-medium col-auto" type="button">Description</h4> -->
          <h4 class="text-muted josefin-sans-medium col-auto" type="button">Specification</h4>
        </div>

        <div class="container-fluid p-4 border rounded-0">
          <div class="row">
            <div class="col-lg-4 ">
              <div class="spec-img-container rounded-0">
                <img class="img-fluid spec-img"
                  [src]="this.endpoint+'/api/product/image-details/get/'+this.subMainImageId"
                  alt="{{ this.product.productName }}" />
              </div>
            </div>
            <div class="col-lg-8">
              <div class="row">
                <div class="col-lg-7 col-md-12">
                  <div class="p-3 rounded border">
                    <div class="table-responsive">
                      <table
                        class="table table-md table-bordered table-hover table-striped text-start align-middle mb-0">
                        <tbody>
                          <tr *ngIf="this.product?.modelNumber">
                            <th class="w-50">Model Number</th>
                            <td>{{ this.product?.modelNumber }}</td>
                          </tr>
                          <tr *ngIf="this.product?.powerSource">
                            <th>Power Source</th>
                            <td>{{ this.product?.powerSource }}</td>
                          </tr>
                          <tr *ngIf="this.product?.ratedInputPower">
                            <th>Rated Input Power</th>
                            <td>{{ this.product?.ratedInputPower }}</td>
                          </tr>
                          <tr *ngIf="this.product?.voltage">
                            <th>Voltage</th>
                            <td>{{ this.product?.voltage }}</td>
                          </tr>
                          <tr *ngIf="this.product?.speedSettings">
                            <th>Speed Settings</th>
                            <td>{{ this.product?.speedSettings }}</td>
                          </tr>
                          <tr *ngIf="this.product?.noLoadSpeed">
                            <th>No Load Speed</th>
                            <td>{{ this.product?.noLoadSpeed }}</td>
                          </tr>
                          <tr *ngIf="this.product?.weightKg">
                            <th>WeightKg</th>
                            <td>{{ this.product?.weightKg }}</td>
                          </tr>
                          <tr *ngIf="this.product?.dimensions">
                            <th>Dimensions</th>
                            <td>{{ this.product?.dimensions }}</td>
                          </tr>
                          <!-- <tr *ngIf="this.product?.productUse">
                <th>Product Use</th>
                <td>{{ this.product?.productUse }}</td>
              </tr>
              <tr *ngIf="this.product?.productType">
                <th>Type</th>
                <td>{{ this.product?.productType }}</td>
              </tr>
              <tr *ngIf="this.product?.style">
                <th>Style</th>
                <td>{{ this.product?.style }}</td>
              </tr>
              <tr *ngIf="this.product?.sellingUnit">
                <th>Selling Unit</th>
                <td>{{ this.product?.sellingUnit }}</td>
              </tr> -->
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </div>



    </div>
  </section>
</section>





<!-- Product Attributes -->





<!-- Footer Bottom -->
<div class="footer_bottom bg-dark text-white py-3">
  <div class="container">
    <div class="row d-flex justify-content-between align-items-center text-center">
      <div class="col-lg-6">
        <p class="mb-0 josefin-sans-regular">&copy; <b>{{ currentYear }}</b> All rights reserved
        </p>
      </div>
      <div class="col-lg-6 justify-content-between align-items-center text-center">
        <p class="mb-0 josefin-sans-regular">Designed & Developed by
          <a href="https://cktechsoln.in/" target="_blank"
            class="text-white text-decoration-none josefin-sans-bold">CKTech Solution Pvt Ltd Madurai.</a>
        </p>
      </div>
    </div>
  </div>
</div>













<div class="modal bg-custom" [style.display]="registerPopup ? 'block':'none'" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title josefin-sans-bold">PERSONAL DETAILS
          <div class="p-0 m-0">
            <span class="text-danger p-0 m-0" [ngStyle]="{'font-size':'12px'}">* Please provide your address details
              accurately, as they will be used for product delivery.</span>
          </div>
        </h5>
        <div></div>
        <button type="button" class="btn-close" (click)="showPopup()" data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="deliveryDetailForm">
          <div class="row">


            <!-- name -->
            <div class="form-floating mb-3 col-12 col-md-12">
              <input type="text" class="form-control" formControlName="customerName" id="floatingInput"
                placeholder="Enter Your Name"
                [ngClass]="{'is-invalid': deliveryDetailForm.get('customerName')?.invalid && deliveryDetailForm.get('customerName')?.touched,
                        'is-valid': deliveryDetailForm.get('customerName')?.valid && deliveryDetailForm.get('customerName')?.touched}">
              <label for="floatingInput" class=" josefin-sans-regular">Name</label>
            </div>
            <!-- phoneNumber -->
            <div class="form-floating mb-3 col-12 col-md-12">
              <input type="tel" class="form-control" maxlength="10" formControlName="phoneNumber" id="floatingInput"
                placeholder="Enter Your Phone Number"
                [ngClass]="{'is-invalid': deliveryDetailForm.get('phoneNumber')?.invalid && deliveryDetailForm.get('phoneNumber')?.touched,
                        'is-valid': deliveryDetailForm.get('phoneNumber')?.valid && deliveryDetailForm.get('phoneNumber')?.touched}">
              <label for="floatingInput" class=" josefin-sans-regular">Phone Number</label>
            </div>
            <!-- Door No -->
            <div class="form-floating mb-3 col-12 col-md-6">
              <input type="text" class="form-control" formControlName="doorNo" id="doorNo" placeholder="D/No" required
                [ngClass]="{'is-invalid': deliveryDetailForm.get('doorNo')?.invalid && deliveryDetailForm.get('doorNo')?.touched,
                        'is-valid': deliveryDetailForm.get('doorNo')?.valid && deliveryDetailForm.get('doorNo')?.touched}">
              <label for="doorNo" class=" josefin-sans-regular">Door No</label>
            </div>

            <!-- Street -->
            <div class="form-floating mb-3 col-12 col-md-6">
              <input type="text" class="form-control" id="street" formControlName="street"
                placeholder="Enter Your Street" required
                [ngClass]="{'is-invalid': deliveryDetailForm.get('street')?.invalid && deliveryDetailForm.get('street')?.touched,
                        'is-valid': deliveryDetailForm.get('street')?.valid && deliveryDetailForm.get('street')?.touched}">
              <label for="street" class=" josefin-sans-regular">Street</label>
            </div>

            <!-- City -->
            <div class="form-floating mb-3 col-12 col-md-6">
              <input type="text" class="form-control" id="city" formControlName="city" placeholder="Enter Your City"
                required [ngClass]="{'is-invalid': deliveryDetailForm.get('city')?.invalid && deliveryDetailForm.get('city')?.touched,
                        'is-valid': deliveryDetailForm.get('city')?.valid && deliveryDetailForm.get('city')?.touched}">
              <label for="city" class=" josefin-sans-regular">City</label>
            </div>

            <!-- State -->
            <div class="form-floating mb-3 col-12 col-md-6">
              <input type="text" class="form-control" id="state" formControlName="state" placeholder="Enter Your state"
                required
                [ngClass]="{'is-invalid': deliveryDetailForm.get('state')?.invalid && deliveryDetailForm.get('state')?.touched,
                        'is-valid': deliveryDetailForm.get('state')?.valid && deliveryDetailForm.get('state')?.touched}">
              <label for="state" class=" josefin-sans-regular">State</label>
            </div>

            <!-- Pin Code -->
            <div class="form-floating mb-3 col-12 col-md-6">
              <input type="tel" class="form-control" id="pinCode" formControlName="pincode" maxlength="6"
                placeholder="Enter Your Pin Code" required oninput="this.value = this.value.replace(/\D/g, '')"
                [ngClass]="{'is-invalid': deliveryDetailForm.get('pincode')?.invalid && deliveryDetailForm.get('pincode')?.touched,
                        'is-valid': deliveryDetailForm.get('pincode')?.valid && deliveryDetailForm.get('pincode')?.touched}">
              <label for="pinCode" class=" josefin-sans-regular">Pin Code</label>
            </div>


          </div>
        </form>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger josefin-sans-regular rounded-0" data-bs-dismiss="modal"
          (click)="showPopup()">Close</button>
        <button type="button" class="btn btn-success josefin-sans-regular rounded-0"
          (click)="deliveryValidation()">Enquiry <i class="bi bi-whatsapp "></i></button>
      </div>
    </div>
  </div>
</div>